import styled, {createGlobalStyle} from 'styled-components'

const MobileView = styled.nav`
  position: fixed;
  background-color: ${props => props.theme.shell.header.menu.active.backgroundColor};
  color: ${props => props.theme.shell.header.menu.active.color};
  margin: 0;
  padding: 0;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  height: 100vh;
  flex-direction: column;
  display: ${props => (props.shouldShow ? 'flex' : 'none')};
  z-index: 3;

  .globe-icon,
  .logout-icon {
    path {
      fill: ${props => props.theme.shell.header.menu.active.color};
    }
  }

  .back-icon {
    polygon:last-child {
      fill: ${props => props.theme.shell.header.menu.active.color};
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.portrait}px) {
    display: none;
  }
`

const MobileContentView = styled.div`
  overflow: scroll;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 20px;
  margin-top: 95px;
`

const RouteLinksView = styled.ul`
  margin: 0;
  padding: 0;

  &.login-route-links {
    margin-bottom: 50px;
  }
`

const RouteLinksItem = styled.li`
  list-style: none;
  position: relative;

  &:last-child {
    margin-bottom: 0;
  }

  a {
    font-size: ${props => props.theme.shell.header.menu.default.fontSize};
    color: ${props => props.theme.shell.header.menu.active.color};
    display: flex;
    align-items: center;
    padding: 16px;
    text-decoration: none;
    border-radius: 4px;

    &.mm-next:after {
      border-color: ${props => props.theme.shell.header.menu.active.color};
      border-style: solid;
      content: '';
      border-top: 2px solid transparent;
      border-left: 2px solid transparent;
      display: block;
      width: 12px;
      height: 12px;
      margin: auto;
      position: absolute;
      left: auto;
      top: 0;
      bottom: 0;
      right: 18px;
      transform: rotate(-45deg);
      box-sizing: border-box;
    }

    &:hover {
      background-color: ${props => props.theme.shell.header.menu.active.hoverBackgroundColor};
      color: ${props => props.theme.shell.header.menu.active.hoverColor};

      &.mm-next:after {
        border-right-color: ${props => props.theme.shell.header.menu.active.hoverColor};
        border-bottom-color: ${props => props.theme.shell.header.menu.active.hoverColor};
      }

      .globe-icon {
        path {
          fill: ${props => props.theme.shell.header.menu.active.hoverColor};
        }
      }
    }
  }

  &.selected {
    a {
      background-color: ${props => props.theme.shell.header.menu.active.selectedBackgroundColor};
      font-family: ${({theme}) => theme.font.fontBold};
      font-weight: ${({theme}) => theme.font.boldFontWeight};

      &:hover {
        background-color: ${props => props.theme.shell.header.menu.active.selectedBackgroundColor};
      }
    }
  }

  &.separator {
    height: 1px;
    margin-bottom: 24px;
    margin-top: 24px;
    background-color: ${props => props.theme.shell.header.menu.active.separatorColor};
  }
`

const RouteLinkText = styled.span`
  display: inline-block;
  margin-left: 20px;
`

const LanguageLinksView = styled.div`
  ul {
    margin: 0;
    padding: 0;

    li {
      list-style: none;
      position: relative;
      margin-bottom: 6px;
      font-size: ${props => props.theme.shell.header.menu.default.fontSize};
      color: ${props => props.theme.shell.header.menu.active.color};
      display: flex;
      align-items: center;
      padding: 16px 16px 12px 60px;
      text-decoration: none;
      border-radius: 4px;

      &:hover {
        background-color: ${props => props.theme.shell.header.menu.active.hoverBackgroundColor};
        color: ${props => props.theme.shell.header.menu.active.hoverColor};
        cursor: pointer;
      }

      &.selected {
        border-radius: 4px;
        color: ${props =>
          props.theme.shell.header.menu.active.selectedColor || props.theme.shell.header.menu.active.color};
        background-color: ${props => props.theme.shell.header.menu.active.selectedBackgroundColor};
        font-family: ${({theme}) => theme.font.fontBold};
        font-weight: ${({theme}) => theme.font.boldFontWeight};

        &:hover {
          color: ${props => props.theme.shell.header.menu.active.selectedHoverColor};
        }
      }
    }
  }
`

const ControlsView = styled.div`
  position: relative;

  [class*='-icon'] {
    position: absolute;
    top: 28px;
    z-index: 1;
  }

  .arrow-icon {
    transform: rotate(180deg);
    display: ${props => (props.shouldShowArrowIcon ? 'block' : 'none')};
    left: 24px;
  }

  .close-icon {
    right: 24px;
  }

  svg {
    flex-shrink: 0;
  }
`

const BarsWrapper = styled.div`
  z-index: 10;
  width: 28px;
  height: 24px;
  cursor: pointer;
  display: block;
  position: ${props => (props.isScrolling ? 'relative' : 'absolute')};
  top: ${props => (props.isScrolling ? 'unset' : '28px')};
  right: ${props => (props.isScrolling ? 'unset' : '20px')};

  @media screen and (min-width: ${props => props.theme.breakpoints.portrait}px) {
    display: none;
  }

  span {
    display: block;
    position: absolute;
    height: 4px;
    width: 100%;
    background: ${props =>
      props.isOpen ? props.theme.shell.header.menu.active.color : props.theme.shell.header.menu.default.color};
    border-radius: 2px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;

    &:nth-child(1) {
      top: ${({isOpen}) => (isOpen ? '9px' : '0')};
      width: ${({isOpen}) => (isOpen ? '0' : '100%')};
      left: ${({isOpen}) => (isOpen ? '50%' : '0')};
    }

    &:nth-child(2) {
      top: 9px;
      transform: ${({isOpen}) => (isOpen ? 'rotate(45deg)' : 'rotate(0deg)')};
    }

    &:nth-child(3) {
      top: 9px;
      transform: ${({isOpen}) => (isOpen ? 'rotate(-45deg)' : 'rotate(0deg)')};
    }

    &:nth-child(4) {
      top: ${({isOpen}) => (isOpen ? '9px' : '18px')};
      width: ${({isOpen}) => (isOpen ? '0' : '100%')};
      left: ${({isOpen}) => (isOpen ? '50%' : '0')};
    }
  }
`

const GlobalStyle = createGlobalStyle`
  body {
    overflow: hidden !important;
  }
`

const HeaderMenuText = styled.span`
  margin-left: 20px;
`

export {
  MobileView,
  MobileContentView,
  RouteLinksView,
  LanguageLinksView,
  ControlsView,
  GlobalStyle,
  RouteLinksItem,
  RouteLinkText,
  BarsWrapper,
  HeaderMenuText,
}
